import { ParlorDetailProps } from "@/types/parlor";

const carouselRichSearch = (regionParlors: ParlorDetailProps[]) => {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: regionParlors.map((parlor, index) => {
      return {
        "@type": "ListItem",
        position: index + 1,
        name: `(비용 할인)${parlor.companyname}`,
        image: parlor.images[0]?.url,
        url: `https://www.goifuneral.co.kr/parlor/${parlor.id}`,
      };
    }),
  };
};

const reviewRichSearch = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "장례 상조 서비스 이용후기",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.8",
    bestRating: "5",
    ratingCount: "178",
  },
  review: [
    {
      "@type": "Review",
      name: "장례식장 후기",
      author: {
        "@type": "Person",
        name: "이**",
      },
      reviewBody:
        "장례식장 예약을 해야 하는데 급박했던 시간 속에 신속하게 알아봐 주시고 처리해 주셨어요.",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "장례식장 후기",
      author: {
        "@type": "Person",
        name: "김**",
      },
      reviewBody:
        "인생에서 고이를 만난 건 정말 운이 좋았다고 생각해요. 부모님이 갑작스럽게 돌아가셔서 정신없었는데, 고이 장례지도사분이 처음부터 장지까지 동행해 주셔서 감사했습니다.",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "장례식장 후기",
      author: {
        "@type": "Person",
        name: "민**",
      },
      reviewBody:
        "밤에도 일 있으면 언제든 연락받아주셨고, 항상 친절하셨습니다. 특히 입관식 때 정성을 다해주셔서 큰 감동을 받았습니다.",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "장례식장 후기",
      author: {
        "@type": "Person",
        name: "이**",
      },
      reviewBody:
        "상조회사를 고민하신다면 주저하지 말고 고이를 선택하라고 추천하고 싶습니다. 처음 장례식장을 정하는 단계에서부터 모든 과정이 끝날 때까지 모든 면에서 프로페셔널함을 느낄 수 있었습니다.",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
    {
      "@type": "Review",
      name: "장례식장 후기",
      author: {
        "@type": "Person",
        name: "고**",
      },
      reviewBody:
        "완벽했다는 표현으로도 감동의 여운이 가시지 않아, 장례식을 잘 치러준 고이에게 다시 한번 감사의 말씀을 드리고 싶습니다.",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
      },
    },
  ],
};

export const funeralRichSearch = {
  carouselRichSearch,
  reviewRichSearch,
};
